import type { SmartAccount } from '@particle-network/aa-plugin';
import { create } from 'zustand';

type State = {
  smartAccount: SmartAccount | null;
};

type Actions = {
  setSmartAccount: (smartAccount: SmartAccount | null) => void;
};

export const useAAPlugin = create<State & Actions>((set) => ({
  smartAccount: null,
  setSmartAccount: (value) => {
    set({ smartAccount: value });
  },
}));
